export default {
    SET_PAYOUTS: (state, payouts) => {
        state.payouts = payouts
    },

    SET_PAGINATION: (state, pagination) => {
        state.pagination = pagination
    },

    SET_LOAD: (state, isLoaded) => {
        state.isLoaded = isLoaded
    },

    SET_FILTERS: (state, filters) => {
        state.filters = filters
    },

    ADD_PAYOUT: (state, payout) => {
        state.payouts.unshift(payout)
    },

    EDIT_PAYOUT: (state, payout) => {
        const payoutIndex = state.payouts.findIndex(it => it.id === payout.id)
        state.payouts.splice(payoutIndex, 1)
        state.payouts.unshift(payout)
    },

    RESET_PAYOUTS: (state) => {
        state.filters = {
            fromDate: new Date(+new Date() - 2419200000).toISOString().split('T')[0],
            toDate: new Date().toISOString().split('T')[0],
            status: null,
            query: null
        }
    }
}
